import { MutationHookOptions } from '@apollo/client';
import { getOperationName } from '@apollo/client/utilities';

import { Offering_OfferingHeaderDocument } from '../../../offering/graphql';
import {
  OfferingSetup_BasicInfoRoute_UpdateBasicInfoMutation,
  OfferingSetup_BasicInfoRoute_UpdateBasicInfoMutationVariables,
  useOfferingSetup_BasicInfoRoute_UpdateBasicInfoMutation,
} from '../../graphql';

const refetchQueries = () => {
  const offeringHeaderQuery = getOperationName(Offering_OfferingHeaderDocument);
  return [offeringHeaderQuery!];
};

export const useUpdateBasicInfoMutation = (
  options: MutationHookOptions<
    OfferingSetup_BasicInfoRoute_UpdateBasicInfoMutation,
    OfferingSetup_BasicInfoRoute_UpdateBasicInfoMutationVariables
  > = {}
) => {
  return useOfferingSetup_BasicInfoRoute_UpdateBasicInfoMutation({
    refetchQueries,
    ...options,
  });
};
